import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'

import * as Types from '../../types.generated'
const defaultOptions = {}
export type IGetJobsiteConfigurationByProjectQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ObjectId']['input']
}>

export type IGetJobsiteConfigurationByProjectQuery = {
  jobsiteConfiguration?: {
    id?: any | null
    projectId: any
    configuration?: string | null
    createdAt?: any | null
    updatedAt?: any | null
    version?: number | null
  } | null
}

export type ISaveJobsiteConfigurationMutationVariables = Types.Exact<{
  input: Types.IJobsiteConfigurationInput
}>

export type ISaveJobsiteConfigurationMutation = {
  saveJobsiteConfiguration?: {
    id?: any | null
    projectId: any
    configuration?: string | null
    createdAt?: any | null
    updatedAt?: any | null
    version?: number | null
  } | null
}

export type IOnJobsiteConfigurationChangeSubscriptionVariables = Types.Exact<{
  projectId: Types.Scalars['ObjectId']['input']
}>

export type IOnJobsiteConfigurationChangeSubscription = {
  jobsiteConfiguration?: {
    id?: any | null
    item?: {
      id?: any | null
      projectId: any
      configuration?: string | null
      createdAt?: any | null
      updatedAt?: any | null
      version?: number | null
    } | null
  } | null
}

export const GetJobsiteConfigurationByProjectDocument = gql`
  query GetJobsiteConfigurationByProject($projectId: ObjectId!) {
    jobsiteConfiguration(projectId: $projectId) {
      id
      projectId
      configuration
      createdAt
      updatedAt
      version
    }
  }
`

/**
 * __useGetJobsiteConfigurationByProjectQuery__
 *
 * To run a query within a React component, call `useGetJobsiteConfigurationByProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobsiteConfigurationByProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobsiteConfigurationByProjectQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetJobsiteConfigurationByProjectQuery(
  baseOptions: Apollo.QueryHookOptions<
    IGetJobsiteConfigurationByProjectQuery,
    IGetJobsiteConfigurationByProjectQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    IGetJobsiteConfigurationByProjectQuery,
    IGetJobsiteConfigurationByProjectQueryVariables
  >(GetJobsiteConfigurationByProjectDocument, options)
}
export function useGetJobsiteConfigurationByProjectLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IGetJobsiteConfigurationByProjectQuery,
    IGetJobsiteConfigurationByProjectQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    IGetJobsiteConfigurationByProjectQuery,
    IGetJobsiteConfigurationByProjectQueryVariables
  >(GetJobsiteConfigurationByProjectDocument, options)
}
export type GetJobsiteConfigurationByProjectQueryHookResult = ReturnType<
  typeof useGetJobsiteConfigurationByProjectQuery
>
export type GetJobsiteConfigurationByProjectLazyQueryHookResult = ReturnType<
  typeof useGetJobsiteConfigurationByProjectLazyQuery
>
export type GetJobsiteConfigurationByProjectQueryResult = Apollo.QueryResult<
  IGetJobsiteConfigurationByProjectQuery,
  IGetJobsiteConfigurationByProjectQueryVariables
>
export const SaveJobsiteConfigurationDocument = gql`
  mutation SaveJobsiteConfiguration($input: JobsiteConfigurationInput!) {
    saveJobsiteConfiguration(jobsiteConfiguration: $input) {
      id
      projectId
      configuration
      createdAt
      updatedAt
      version
    }
  }
`
export type ISaveJobsiteConfigurationMutationFn = Apollo.MutationFunction<
  ISaveJobsiteConfigurationMutation,
  ISaveJobsiteConfigurationMutationVariables
>

/**
 * __useSaveJobsiteConfigurationMutation__
 *
 * To run a mutation, you first call `useSaveJobsiteConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveJobsiteConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveJobsiteConfigurationMutation, { data, loading, error }] = useSaveJobsiteConfigurationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveJobsiteConfigurationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ISaveJobsiteConfigurationMutation,
    ISaveJobsiteConfigurationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ISaveJobsiteConfigurationMutation,
    ISaveJobsiteConfigurationMutationVariables
  >(SaveJobsiteConfigurationDocument, options)
}
export type SaveJobsiteConfigurationMutationHookResult = ReturnType<
  typeof useSaveJobsiteConfigurationMutation
>
export type SaveJobsiteConfigurationMutationResult =
  Apollo.MutationResult<ISaveJobsiteConfigurationMutation>
export type SaveJobsiteConfigurationMutationOptions =
  Apollo.BaseMutationOptions<
    ISaveJobsiteConfigurationMutation,
    ISaveJobsiteConfigurationMutationVariables
  >
export const OnJobsiteConfigurationChangeDocument = gql`
  subscription OnJobsiteConfigurationChange($projectId: ObjectId!) {
    jobsiteConfiguration(projectId: $projectId) {
      item {
        id
        projectId
        configuration
        createdAt
        updatedAt
        version
      }
      id
    }
  }
`

/**
 * __useOnJobsiteConfigurationChangeSubscription__
 *
 * To run a query within a React component, call `useOnJobsiteConfigurationChangeSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnJobsiteConfigurationChangeSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnJobsiteConfigurationChangeSubscription({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useOnJobsiteConfigurationChangeSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    IOnJobsiteConfigurationChangeSubscription,
    IOnJobsiteConfigurationChangeSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSubscription<
    IOnJobsiteConfigurationChangeSubscription,
    IOnJobsiteConfigurationChangeSubscriptionVariables
  >(OnJobsiteConfigurationChangeDocument, options)
}
export type OnJobsiteConfigurationChangeSubscriptionHookResult = ReturnType<
  typeof useOnJobsiteConfigurationChangeSubscription
>
export type OnJobsiteConfigurationChangeSubscriptionResult =
  Apollo.SubscriptionResult<IOnJobsiteConfigurationChangeSubscription>
